const routes = [
	{ path: '/', name: 'home', redirect: '/tecnici' }, 
	{ path: '/tecnici', alias: '/', name: 'tecnici', component: require('../views/Tecnici.vue').default },
	{ path: '/corsi', name: 'corsi', component: require('../views/Corsi.vue').default },
	{ path: '/pannellotecnici/:tecnicoid?', name: 'pannellotecnici', component: require('../views/PannelloTecnici.vue').default },
	{ path: '/modelliemail', name: 'modelliemail', component: require('../views/ModelliEmail.vue').default },
	{ path: '/circolari', name: 'circolari', component: require('../views/CircolariInviate.vue').default },
	{ path: '/circolariautomatiche', name: 'circolariautomatiche', component: require('../views/CircolariAutomatiche.vue').default },
	{ path: '/referenti', name: 'referenti', component: require('../views/Referenti.vue').default },
	{ path: '/faq', name: 'faq', component: require('../views/Faq.vue').default },
];

export default routes;